// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"26":"b6639a8e","33":"3bca5785","564":"bc5aa63b","771":"0b4119fe"}[chunkId] + ".chunk.js";
};